import { FormEvent, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout } from "../components/layout/Layout";
import { ArticleCard } from "../components/posts/ArticleCard";
import { SEO } from "../components/seo/SEO";
import { site } from "../data/site";
import { searchPosts } from "../lib/search";

export function SearchPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const initialQuery = new URLSearchParams(location.search).get("q") ?? "";
  const [query, setQuery] = useState(initialQuery);
  const results = useMemo(() => searchPosts(initialQuery), [initialQuery]);

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const nextQuery = query.trim();
    navigate(nextQuery ? `/search?q=${encodeURIComponent(nextQuery)}` : "/search");
  }

  return (
    <Layout>
      <SEO
        title={`Search ${site.name}`}
        description="Search published yawiki.org articles by title, category, tag, author, and excerpt."
        canonical={`${site.url}/search`}
      />
      <header className="page-header">
        <p className="eyebrow">Search</p>
        <h1>Search articles</h1>
        <p>Search only includes published posts. Drafts and future-dated articles stay hidden.</p>
      </header>

      <form className="search-page-form" onSubmit={handleSubmit} role="search">
        <label htmlFor="search-page-input">Search term</label>
        <div>
          <input
            id="search-page-input"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            type="search"
            placeholder="Try MDX, SEO, wiki"
          />
          <button type="submit">Search</button>
        </div>
      </form>

      {initialQuery ? (
        <section className="section" aria-labelledby="search-results-title">
          <div className="section-heading">
            <h2 id="search-results-title">Results for “{initialQuery}”</h2>
            <span>{results.length} found</span>
          </div>
          {results.length > 0 ? (
            <div className="article-list">
              {results.map((post) => (
                <ArticleCard key={post.slug} post={post} />
              ))}
            </div>
          ) : (
            <p className="empty-state">No published articles match this search.</p>
          )}
        </section>
      ) : null}
    </Layout>
  );
}
